module.exports = __webpack_public_path__ + "img/icon_report_empty_logo_1.fd7122c9.png";